<template>
    <section class="section a-section a-section--fullheight">
        <div class="container">
            <div class="columns">
                <div
                    v-show="img == null"
                    class="column"
                >
                    <div class="a-webcam">
                        <vue-web-cam
                            ref="webcam"
                            :device-id="deviceId"
                            width="100%"
                            @error="onError"
                            @cameras="onCameras"
                            @camera-change="onCameraChange"
                        />
                    </div>
                    <div class="columns is-mobile is-vcentered">
                        <div class="column has-text-right">
                            Wybierz kamerę:
                        </div>
                        <div class="column">
                            <div class="select is-fullwidth">
                                <select v-model="camera">
                                    <option>-- Select Device --</option>
                                    <option
                                        v-for="device in devices"
                                        :key="device.deviceId"
                                        :value="device.deviceId"
                                    >{{ device.label }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <button
                        class="button is-primary a-button a-button--main"
                        @click="onCapture"
                    >
                        Zrób zdjęcie
                    </button>
                </div>
                <div
                    v-show="img == null || (img != null && libraryPhoto == true)"
                    class="column"
                >
                    <div class="columns">
                        <div class="column">
                            <vue-picture-input
                                :custom-strings="{
                                        tap:'Załaduj z galerii',
                                        change:'Zmień zdjęcie',
                                        remove:'Załaduj jeszcze raz'
                                    }"
                                class="a-pictureInput"
                                :class="{'a-pictureInput--button':!libraryPhoto}"
                                button-class="button a-button a-button--main"
                                :removable="true"
                                remove-button-class="button a-button a-button--main"
                                @change="onChange"
                                @remove="onRemove"
                                :hide-change-button="true"
                            />
                            <button
                                v-if="img != null"
                                class="button is-primary a-button a-button--main"
                                @click="savePhoto"
                            >
                                Zapisz
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    v-show="img != null && libraryPhoto == false"
                    class="column"
                >
                    <div class="a-webcam">
                        <figure class="figure">
                            <img :src="img" class="img-responsive" />
                        </figure>
                    </div>
                    <p class="a-text a-text--title a-text--marginBottom has-text-centered">Czy chcesz dodać to zdjęcie?</p>
                    <button
                        class="button a-button a-button--main a-button--marginBottom"
                        @click="onStart"
                    >
                        Wykonaj jeszcze raz
                    </button>
                    <button
                        class="button is-primary a-button a-button--main"
                        @click="savePhoto"
                    >
                        Zapisz
                    </button>
                </div>
                <div class="column">
                    <hr class="a-hr a-hr--noMarginTop">
                    <button
                        class="button a-button a-button--main"
                        @click="$router.push({ name: 'loading-photos', params: { token } })"
                    >
                        Powrót do rozładunku
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { WebCam } from 'vue-web-cam'
import vuePictureInput from 'vue-picture-input'
export default {
    name: "App",
    components: {
        'vue-web-cam': WebCam,
        vuePictureInput
    },
    data() {
        return {
            img: null,
            camera: null,
            deviceId: null,
            devices: [],
            libraryPhoto: false
        };
    },
    computed: {
        device() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        },
        token() {
            return this.$store.getters.token
        }
    },
    watch: {
        camera(id) {
            this.deviceId = id;
        },
        devices() {
            // once we have a list select the first one
            let camera = {}
            if(this.devices.length == 1){
                camera = this.devices[0]
            } else {
                const idx = this.devices.findIndex(device => {
                    return device.label.includes('back') || device.label.includes('yln')
                })
                // if there is no back camera
                if(idx == -1){
                    // set to last one
                    camera = this.devices[this.devices.length - 1]
                } else {
                    camera = this.devices[idx]
                }
            }

            if (camera) {
                this.camera = camera.deviceId;
                this.deviceId = camera.deviceId;
            }
        }
    },
    methods: {
        onStart() {
            this.img = null
            this.$refs.webcam.start()
        },
        onCapture() {
            this.img = this.$refs.webcam.capture()
        },
        onError(error) {
            console.log('On Error Event', error)
        },
        onCameras(cameras) {
            this.devices = cameras
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId
            this.camera = deviceId
        },
        savePhoto() {
            this.$store.dispatch('addUnloadingPhoto', this.img)
            this.$router.push({ name: 'unloading-photos', params: { token: this.token } })
        },
        onChange (image) {
            if (image) {
                this.img = image
                this.libraryPhoto = true
            } else {
                console.log('FileReader API not supported: use the <form>')
            }
        },
        onRemove() {
            this.img = null
            this.libraryPhoto = false
        }
    }
};
</script>
